import gsuite from "@/assets/tech-logos/gsuite.webp";
import office from "@/assets/tech-logos/office.webp";
import ringcentral from "@/assets/tech-logos/ringcentral.svg";
import microsoft from "@/assets/tech-logos/microsoft.webp";
import threecx from "@/assets/tech-logos/3cx.webp";
import logo7 from "@/assets/tech-logos/logo7.webp";
import logo8 from "@/assets/tech-logos/logo8.webp";
import logo9 from "@/assets/tech-logos/logo9.webp";

const logos = [gsuite, office, ringcentral, microsoft, threecx, logo7, logo8, logo9];

export function TechLogos() {
  return (
    <section className="py-6 md:py-10 bg-background">
      <div className="container-main">
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold uppercase inline-block text-foreground bg-muted px-4 py-2">
            Our Technologies
          </h2>
        </div>
        <div className="bg-muted rounded-2xl p-8">
          <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-8 items-center justify-items-center gap-6 sm:gap-8 md:gap-12">
            {logos.map((logo, i) => (
              <img
                key={i}
                src={logo}
                alt="Technology partner"
                className="h-8 md:h-12 w-auto object-contain grayscale hover:grayscale-0 transition-all opacity-70 hover:opacity-100"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
